import { measureTextWidth } from './utils/textWidth';

interface Props {
  x?: number | string;

  y?: number | string;

  payload?: { value: string | number; index?: number };

  index?: number;

  /** Width of the whole axis, shared by all visible ticks. */
  width?: number | string;

  visibleTicksCount?: number;

  formatter: (value: any, index: number) => string;

  subLabel: (value: string | number) => string | null | undefined;

  fontFamily?: string;

  fontSize: number;

  fill: string;

  subFill: string;
}

/** Bottom-axis tick drawing the formatted label with a smaller second line, which is hidden when it is wider than the tick's share of the axis. */
export default function AxisTickWithSubLabel({
  x,
  y,
  payload,
  index,
  width,
  visibleTicksCount,
  formatter,
  subLabel,
  fontFamily,
  fontSize,
  fill,
  subFill,
}: Props) {
  if (payload == null) return null;

  const label = formatter(payload.value, payload.index ?? index ?? 0);
  const sub = subLabel(payload.value);
  const subFontSize = fontSize - 1;
  const slotWidth = Number(width) / Math.max(visibleTicksCount ?? 1, 1);
  const showSub =
    sub != null &&
    sub !== '' &&
    (!Number.isFinite(slotWidth) ||
      measureTextWidth(sub, subFontSize, fontFamily) <= slotWidth);

  return (
    <g transform={`translate(${Number(x)},${Number(y)})`}>
      <text
        textAnchor='middle'
        dy='0.71em'
        fontFamily={fontFamily}
        fontSize={fontSize}
        fill={fill}
      >
        {label}
      </text>
      {showSub && (
        <text
          textAnchor='middle'
          y={fontSize + 4}
          dy='0.71em'
          fontFamily={fontFamily}
          fontSize={subFontSize}
          fontWeight={600}
          fill={subFill}
        >
          {sub}
        </text>
      )}
    </g>
  );
}
